document.addEventListener('DOMContentLoaded', function() {
  const tabListWraps = document.querySelectorAll('.tab-list-wrap');

  function checkScroll(wrap) {
    const tabList = wrap.querySelector('.section-product-list_tab-list');
    if (!tabList) return;

    if (wrap.scrollWidth > wrap.clientWidth) {
      // スクロールが必要な場合
      if (!tabList.classList.contains('has-scroll')) {
        tabList.classList.add('has-scroll');
        tabList.addEventListener('animationend', () => {
          tabList.classList.remove('has-scroll');
        }, { once: true });
      }
      tabList.classList.remove('no-scroll');
    } else {
      // スクロールが不要な場合
      tabList.classList.add('no-scroll');
      tabList.classList.remove('has-scroll');
    }
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        checkScroll(entry.target);
      }
    });
  });

  tabListWraps.forEach(wrap => {
    observer.observe(wrap);
  });
});
